<template>
    <div class="popup" v-if="open">
        <div class="popup__container">
            <div class="popup__modal">
                <div class="popup__modal-title">
                    {{ title }}
                    <div class="popup__modal-close-btn" @click="$emit('closePopup')"></div>
                </div>
                <template v-if="!success && !sending">
                    <div class="popup__modal-text">
                        {{ text }}
                    </div>
                    <div class="popup__modal-field">
                        <input
                            v-model="form.name"
                            type="text"
                            placeholder="Имя *"
                            required
                        >
                    </div>
                    <div class="popup__modal-field">
                        <input
                            v-model="form.phone"
                            v-mask="'+7 (###) ###-##-##'"
                            type="text"
                            placeholder="Телефон *"
                            required>
                    </div>
                    <Btn
                        :class="['popup__modal-submit',
                            {'__disabled':  v$.$invalid}
                        ]"
                        :mode="`red`"
                        :text="btn"
                        @clickDef="sendForm"
                    />
                    <div class="popup__modal-politics">
                        Нажимая кнопку "{{ btn }}", вы соглашаетесь с <a href="/policy/" target="_blank">политикой конфиденциальности</a>
                    </div>
                </template>
                <template v-else-if="sending && !success">
                    <div class="popup__modal-sending">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            style="margin: auto; border-radius: 50%; overflow: hidden; display: block;" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <defs>
                                <mask id="ldio-m4re25r0t7-mask">
                                    <rect rx="50%" x="15" y="15" width="70" height="70" fill="white"></rect>
                                </mask>
                            </defs>
                            <rect rx="50%" x="15" y="15" width="70" height="70" fill="#ffc83a"></rect>
                            <g mask="url(#ldio-m4re25r0t7-mask)">
                                <rect x="-100" y="-250" width="300" height="300" rx="90" ry="90" fill="#fe3e47" opacity="0.4">
                                    <animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" values="0 50 -100;90 50 -100" keyTimes="0;1"></animateTransform>
                                </rect>

                                <rect  x="-100" y="-260" width="300" height="300" rx="95" ry="95" fill="#1b42ce" opacity="0.4">
                                    <animateTransform attributeName="transform" type="rotate" dur="1.5151515151515151s" repeatCount="indefinite" values="0 50 -110;90 50 -110" keyTimes="0;1"></animateTransform>
                                </rect>

                                <rect x="-100" y="-270" width="300" height="300" rx="100" ry="100" fill="#1b42ce" opacity="0.4">
                                    <animateTransform attributeName="transform" type="rotate" dur="3.0303030303030303s" repeatCount="indefinite" values="0 50 -120;90 50 -120" keyTimes="0;1"></animateTransform>
                                </rect>
                            </g>
                        </svg>
                    </div>
                </template>
                <template v-else>
                    <div class="popup__modal-text">
                        Ваша заявка отправлена, наш менеджер скоро с Вами свяжется
                    </div>
                </template>
            </div>
        </div>
        <div class="popup__overlay" @click="$emit('closePopup')"></div>
    </div>
</template>

<script>
import Btn from "@/components/blocks/Btn";
import {mask} from 'vue-the-mask';
import axios from 'axios';
import { useVuelidate } from '@vuelidate/core'
import { minLength, required } from '@vuelidate/validators'
import { API_BASE } from '@/config'

export default {
    setup () {
        return { v$: useVuelidate() }
    },
    name: "Popup",
    components: {Btn},
    directives: {mask},
    props: {
        open: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: 'Заказать событие'
        },
        text: {
            type: String
        },
        url: {
            type: String,
            default: () => `${API_BASE}/api/leads/`
        },
        btn: {
            type: String,
            default: 'Заказать'
        }
    },
    data() {
        return {
            form: {
                name: '',
                phone: ''
            },
            success: false,
            sending: true
        }
    },
    methods: {
        sendForm() {
            let formBody = new FormData();
            this.sending = true;

            for (let k in this.form) {
                formBody.append(k, this.form[k])
            }

            if (this.url.includes('/api/leads/')) {
                formBody.append('lead_type', 'court')
            }

            if (window?.ym) window.ym(95371295,'reachGoal','2')

            const headers = {'Content-Type': 'application/json'};
            if (typeof window !== 'undefined' && window.csrfToken) {
              headers['X-CSRFToken'] = window.csrfToken;
            }
            axios({
                method: 'post',
                url: this.url,
                headers,
                data: formBody,
            }).then(response => {
                this.success = response.data;
                this.sending = false;
            }).catch((e) => {
                this.sending = false;
                this.success = 'Ошибка при попытке отправить форму. Попробуйте позже'
            })
        }
    },
    watch: {
        open: function() {
            this.form = {name: '', phone: ''};
            this.success = false;
            this.sending = false;
        }
    },
    validations () {
        return {
            form: {
                phone: {
                    required,
                    minLength: minLength(18)
                },
                name: {
                    required,
                    minLength: minLength(2)
                }
            }
        }
    }
}
</script>

<style lang="scss">
.popup {
    display: flex;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 3;

    &__overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #00000099;
        z-index: 1;
        cursor: pointer;
    }
    
    &__modal-close-btn {
        position: absolute;
        right: 20px;
        top: 20px;
        width: 25px;
        height: 25px;
        cursor: pointer;
        
        &::before,
        &::after {
            content: '';
            position: absolute;
            width: 30px;
            height: 1px;
            background: #000;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
        }

        &:after {
            transform: translateY(-50%) rotate(45deg);
        }

        &:before {
            transform: translateY(-50%) rotate(-45deg);
        }
    }

    &__modal-sending {
        border-radius: 50%;
    }

    &__modal {
        display: flex;
        flex-direction: column;
        position: absolute;
        padding: 80px 35px 50px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 540px;
        min-height: 300px;
        border-radius: 20px;
        background: #fff;
        z-index: 2;
        color: #000;
        overflow: hidden;

        @include below($mobile) {
            width: calc(100% - 20px);
            padding: 50px 15px 20px;
        }

        @include below($mobileS) {
            padding: 50px 10px 20px;
        }

        &:before {
            position: absolute;
            content: '';
            width: 255px;
            height: 255px;
            left: -20px;
            bottom: -70px;
            background: url("data:image/svg+xml,%3Csvg width='625' height='840' viewBox='-215 0 840 840' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M-208.622 492.735C-194.537 502.867 -179.594 512.616 -163.952 521.856C-129.739 542.072 -93.2843 559.159 -55.6071 572.641C45.1625 608.703 151.964 618.552 262.002 601.962C264.709 613.338 267.133 624.201 269.265 634.195C274.958 660.862 279.359 686.472 282.39 710.528C183.13 725.365 86.493 717.774 -5.01268 687.91C-82.1026 662.755 -139.097 627.149 -173.893 601.142C-180.654 587.017 -186.627 572.481 -191.799 557.562C-199.162 536.318 -204.771 514.67 -208.622 492.735ZM-214.346 398.214C-212.73 366.927 -207.724 336.276 -199.403 306.526C-183.776 318.019 -154.022 337.066 -104.908 358.397C-66.3429 375.142 -24.2386 389.956 23.7742 403.679C80.6633 420.161 128.472 429.824 165.871 432.396C182.464 433.534 193.507 432.976 200.131 432.224C203.992 437.612 210.919 448.593 219.621 468.086C234.433 501.273 246.825 541.962 256.479 579.571C150.969 595.149 48.6396 585.562 -47.8677 551.025C-127.269 522.61 -184.205 483.38 -212.969 460.733C-214.964 440.076 -215.431 419.211 -214.346 398.214ZM-175.499 242.032C-151.729 191.124 -118.334 146.063 -76.2424 108.104C-34.1522 70.1453 14.1068 41.5669 67.1936 23.1622C105.605 9.8451 145.326 2.24635 185.729 0.451419C149.404 19.7716 106.004 47.6986 62.1201 87.1535C61.8762 87.3734 61.6418 87.5848 61.3983 87.8044C-12.2633 154.235 -68.7718 236.505 -106.702 332.476C-139.109 317.742 -161.211 304.645 -174.453 295.91C-182.628 290.521 -188.416 286.154 -192.129 283.173C-187.33 269.226 -181.788 255.505 -175.499 242.032ZM236.962 1.26708C275.334 4.18401 312.699 12.2322 348.545 25.2736C311.645 41.9696 258.11 71.0886 203.26 117.815C198.689 121.714 194.181 125.664 189.733 129.676C115.001 197.072 57.9767 280.721 19.9978 378.676C-18.7823 367.263 -53.5282 355.08 -85.6384 341.646C-49.0173 248.673 5.57729 169.057 76.7724 104.851C77.0025 104.643 77.2369 104.432 77.4674 104.224C137.793 49.9861 197.076 18.4098 236.962 1.26708ZM505.115 126.394C487.306 134.2 455.965 150.452 413.069 182.257C389.609 199.652 365.797 219.264 340.933 241.687C330.649 250.962 320.181 260.722 309.489 270.998C266.768 312.054 234.487 348.647 213.543 379.759C204.245 393.571 199.203 403.417 196.536 409.522C190.914 410.08 180.66 410.534 164.602 409.279C141.734 407.49 102.349 401.794 42.1625 385.035C81.0211 285.685 140.182 201.709 218.149 135.292C282.386 80.567 344.604 50.9771 378.454 37.4733C379.88 38.1202 381.301 38.771 382.722 39.4352C428.57 60.8384 469.671 90.0542 505.115 126.394ZM601.572 282.106C619.348 333.388 626.934 386.999 624.12 441.452C621.305 495.906 608.236 548.452 585.274 597.633C582.812 602.899 580.244 608.102 577.58 613.244C579.035 572.074 576.589 520.489 564.426 462.814C543.873 365.34 500.824 274.849 436.41 193.655C465.355 172.946 487.757 160.352 501.948 153.25C510.612 148.918 517.242 146.1 521.68 144.376C557.13 185.101 583.996 231.399 601.572 282.106ZM474.731 741.382C478.731 701.071 480.283 640.192 467.267 569.379C447.938 464.203 402.803 366.985 333.055 280.247C362.763 252.104 390.688 228.111 417.944 207.319C480.392 285.858 522.1 373.354 541.962 467.553C558.671 546.798 556.349 614.017 551.242 657.213C532.652 684.295 510.851 709.165 486.017 731.562C482.304 734.911 478.541 738.183 474.731 741.382ZM308.819 826.651C310.979 807.373 312.607 772.081 306.5 718.896C303.415 691.004 298.442 660.898 291.716 629.403C276.11 556.216 258.431 497.742 239.178 455.607C230.08 435.71 222.633 424.039 217.998 417.756C220.33 412.607 225.071 403.499 234.19 390.219C247.187 371.299 271.836 340.013 316.447 296.242C383.047 379.573 426.177 472.801 444.688 573.531C459.937 656.505 454.442 725.165 449.202 761.249C416.494 784.738 380.788 803.256 342.581 816.503C331.431 820.37 320.171 823.747 308.819 826.651ZM27.0504 800.232C-23.8559 776.467 -68.9143 743.076 -106.87 700.988C-122.482 683.677 -136.5 665.324 -148.879 646.019C-114.001 667.83 -68.1558 691.456 -12.1404 709.736C82.5391 740.635 182.427 748.559 284.946 733.355C288.409 768.798 288.111 794.492 287.162 810.331C286.576 820.107 285.683 827.299 284.952 832.003C251.626 838.462 217.598 840.836 183.23 839.064C128.778 836.256 76.2316 823.192 27.0504 800.232Z' fill='%23FCF2D3'/%3E%3C/svg%3E%0A") center/cover no-repeat;
            z-index: -1;
        }

        &-title {
            font-family: BOWLER, sans-serif;
            font-size: 34px;
            font-weight: 400;
            text-align: center;

            @include below($mobile) {
                font-size: 24px;
            }
        }

        &-text {
            padding: 0 15px;
            margin-top: 10px;
            font-family: Montserrat, sans-serif;
            font-size: 20px;
            font-weight: 300;
            text-align: center;

            @include below($mobile) {
                font-size: 16px;
            }
        }

        &-field {
            margin-top: 25px;

            input {
                width: 100%;
                padding: 15px 20px;
                border-radius: 50px;
                border: none;
                background: #F4F4F4;
            }
        }

        &-submit {
            display: flex !important;
            margin: 40px auto 20px !important;
            transition: .2s ease-in;
            
            @include below($mobile) {
                margin: 20px auto 20px !important;
            }

            &.__disabled {
                pointer-events: none;
                opacity: .7;
            }
        }

        &-politics {
            padding: 0 35px;
            font-family: Montserrat, sans-serif;
            font-size: 12px;
            font-weight: 300;
            text-align: center;

            @include below($mobile) {
                padding: 0 10px;
            }

            a {
                text-decoration: underline;
                
                &:hover {
                    text-decoration: none;
                }
            }
        }
    }
}
</style>